import { t } from '@/utils/i18n'
import { Notifier } from '@/utils/notifier'
import axios from 'axios'
import qs from 'qs'

const handleNotification = (type, response) => {
  if (response?.data?.notice) {
    Notifier.showFlash(type, response?.data?.notice)
  }
}

export const updateCsrfToken = () => {
  const csrfToken = document.querySelector('meta[name=csrf-token]')
  if (csrfToken) {
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken.getAttribute('content')
  }
}

// Set default headers first
axios.defaults.headers.common = {
  ...axios.defaults.headers.common,
  'Content-Type': 'application/json',
  Accept: 'application/json'
}

// Then set CSRF token (will run when DOM is ready via initialize())
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateCsrfToken)
} else {
  updateCsrfToken()
}

axios.interceptors.request.use(config => {
  config.paramsSerializer = {
    serialize: params => {
      return qs.stringify(params, {
        arrayFormat: 'brackets',
        encode: false
      })
    }
  }

  // Ensure CSRF token is current for non-GET requests
  if (config.method !== 'get') {
    const csrfToken = document.querySelector('meta[name=csrf-token]')
    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken.getAttribute('content')
    }
  }

  return config
})

axios.interceptors.response.use(
  response => {
    handleNotification('notice', response)
    return response
  },
  async error => {
    const originalRequest = error.config

    // Retry 401 once after delay (helps with race conditions during page load/auth)
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      // Wait for authentication to settle
      await new Promise(resolve => setTimeout(resolve, 100))

      // Update CSRF token before retry
      const csrfToken = document.querySelector('meta[name=csrf-token]')
      if (csrfToken && originalRequest.method !== 'get') {
        originalRequest.headers['X-CSRF-Token'] = csrfToken.getAttribute('content')
      }

      // Retry the request
      return axios(originalRequest)
    }

    // If retry also failed with 401, reload page
    if (error.response?.status === 401) {
      Turbo.visit(window.location)
    } else if (error.response?.data?.notice) {
      handleNotification('alert', error.response)
    } else {
      Notifier.showFlash('alert', t('generic_error_message'))
    }

    return Promise.reject(error)
  }
)
